module.exports = __webpack_public_path__ + "img/download-icon.2dd2de44.svg";